/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import Contact from "./Contact";

/* Render Contact app into the pug template, pulling props from global window */
function render(props) {
  hydrate(<Contact {...props} />, document.getElementById("react"));
}
render(window.reactProps);
